<template>
<div>
  <q-select
  autocomplete="off"
  filled
  multiple
  v-model="model"
  use-input
  use-chips
  input-debounce="0"
  :label="label"
  :options="options"
  @filter="filterFn"
  @filter-abort="abortFilterFn"
  style="width: 100%"
  map-options
  emit-value
  >
  <template v-slot:no-option>
    <q-item>
      <q-item-section class="text-grey">
        No results
      </q-item-section>
    </q-item>
  </template>
</q-select>

</div>

</template>
<script type="ts" setup>
import web from 'src/services/web';
import { ref, watch, inject,onMounted } from 'vue';
let model= ref(null)

const props = defineProps({
  modelValue: String,
  filterId:String,
  promotion: Object,
  url: String,
  location: String,
  label: String
})
const emit = defineEmits(['update:modelValue'])

const basedata = inject("basedata")
const storage = inject("storage")
const options = ref([])
let alleOptions = []

console.log("uopdate",props)

watch(() => model.value,
    (newVal) => {
      console.log("cc uopdate",props.filterId)
      emit('update:modelValue', newVal)

      if(typeof(props.filterId)!=="undefined"){
        storage.set(props.filterId,newVal)
      }

  }  );

function filterFn (val, update) {
    update(() => {
        if (val === '') {
        options.value = alleOptions
        }
        else {
            const needle = val.toLowerCase()
            options.value = alleOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
        }
    })
}




onMounted(()=> {
  setTimeout(() => {

    reload()
  }, 1000);

  if(typeof(props.filterId)!=="undefined"){
    let x=storage.get(props.filterId)
    console.log("uopdate",typeof(x))
        model.value=storage.get(props.filterId)
      }

})

async function reload(){
  if(props.url.match("basedata")){
    let property  = props.url.replace("basedata.","")
    // console.log('propery',property)
    // console.log('basedata',basedata)
    // console.log('basedata[property]',basedata[property])
    alleOptions   = basedata[property]
    options.value = basedata[property]
    return;
  }

  if(props.promotion==null){
    console.log("Promotion is null")
    let data= await web.post(props.url,{forSelect:true})
    alleOptions=data.myArray
    options.value=data.myArray
    return;
  }
  console.log("props.url   ccccc",props)
  console.log("props.url   ccccc",props)


    let data= await web.post(props.url,{id_promotion:props.promotion._id,forSelect:true})
    alleOptions=data.myArray
    options.value=data.myArray
}

function  abortFilterFn () {
    // console.log('delayed filter aborted')
    }


</script>
